import $ from 'jquery';
import Countdown from 'controller/countdown';

const ITEM_KEY = 'hideBottomBannerV1';

export default class SkinBannerView {
    constructor(params) {
        let me = this;
        me.countdown = new Countdown(
            SkinBannerView.getSections(),
            params.startEpoch,
            params.endEpoch,
            params.previewEpoch
        );
        me.bannerId = params.bannerId;
    }

    init() {
        let me = this;
        me.countdown.init();
        $(document).ready(() => {
            this.ready();
        });
    }

    ready() {
        this.setupSelectors();
        this.setupEvents();
    }

    setupSelectors() {
        let me = this;
        me.$skinBannerWrapper = $('#skin-banner-wrapper-bottom');
        me.closeBanner = me.$skinBannerWrapper.find('.close-banner');
        me.$returnToTop = $('#return-to-top');
        me.$chatContent = $('#chat-button, #webchat-container');
    }

    setupEvents() {
        let me = this;
        $(window).on('scroll', function() {
            if (me.$skinBannerWrapper.length > 0 && localStorage.getItem(ITEM_KEY) != me.bannerId) {
                if ($(window).scrollTop() > 500) {
                    me.$skinBannerWrapper.fadeIn(750);
                    me.$returnToTop.css('bottom', me.$skinBannerWrapper.height() + 30).delay(750);
                    me.$chatContent.addClass('chat-location');
                } else {
                    me.$skinBannerWrapper.fadeOut(500);
                    me.$returnToTop.css('bottom', '').delay(1000);
                    me.$chatContent.removeClass('chat-location');
                }
            }
        });

         me.closeBanner.on('click', function () {
            localStorage.setItem(ITEM_KEY, me.bannerId);
             me.$skinBannerWrapper.fadeOut(250);
             me.$returnToTop.css('bottom', '').delay(750);
        });
    }

    static getSections() {
        return [
            {
                name: 'carousel',
                $selector: $('#carousel-widget').find('div[data-type="carousel-clock"]')
            },
            {
                name: 'banner',
                $selector: $('#skin-banner-wrapper, #skin-banner-wrapper-bottom')
            },
            {
                name: 'pageBanner',
                $selector: $('#page-banner-block')
            }
        ];
    }
}